// The pickers' one-kind upload, as their callers were written before the upload took several
// kinds (#309): `useMediaUpload` with an image's or a video's kinds. New code calls
// `useMediaUpload` (media-upload.tsx); this file goes once its callers have moved.
import { AUDIO_ONLY, IMAGE_ONLY, VIDEO_ONLY, useMediaUpload, type MediaUpload } from "./media-upload";

export { UploadState } from "./media-upload";

export type ImageUpload = MediaUpload;

interface ImageUploadOptions extends Omit<Parameters<typeof useMediaUpload>[0], "kinds"> {
  /** What the picker takes: images (the default), videos or audios (the video composer's, #260). */
  kind?: "image" | "video" | "audio";
}

const KINDS = { image: IMAGE_ONLY, video: VIDEO_ONLY, audio: AUDIO_ONLY } as const;

export function useImageUpload({ kind = "image", ...options }: ImageUploadOptions): ImageUpload {
  return useMediaUpload({ ...options, kinds: KINDS[kind] });
}
